import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { DisclosureItemProps } from 'libs/contentful/props';

import { liveUpdateAttrs } from 'libs/contentful/utils';

const DisclosureItem = ({ sys, copy }: DisclosureItemProps) => {
  return (
    <div {...liveUpdateAttrs(sys?.id, 'copy')}>
      <RichTextCopy copy={copy} ySpacing={`sm`} />
    </div>
  );
};
export default DisclosureItem;
